import { render, staticRenderFns } from "./AwardsDetailsSection.vue?vue&type=template&id=069ebc43&scoped=true"
import script from "./AwardsDetailsSection.vue?vue&type=script&lang=js"
export * from "./AwardsDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./AwardsDetailsSection.vue?vue&type=style&index=0&id=069ebc43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ebc43",
  null
  
)

export default component.exports